import React, { useEffect, useState } from "react";
import { RiCloseLargeLine } from "react-icons/ri";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import "../../style/Profile.css"

const ProfileInfo = ({
  formData,
  handleInputChange,
  sideImg,
  handleClose,
  profileData,
  setProfileData,
  handleValidatedInput,
  firstNameError,
  lastNameError,
  emailError,
  phoneNumberError
}) => {
  const [isFocused, setIsFocused] = useState(false);
  useEffect(() => {
    setProfileData(formData);
  }, []);

  return (
    <div>
      <div className="flex justify-between items-center bg-white shadow-md p-4 fixed w-full z-50">
        <div className="flex items-center gap-3">
          <img
            className="cursor-pointer"
            onClick={handleClose}
            src={sideImg}
            width={"32px"}
            height={"32px"}
            alt={"sideImg"}
          />
          <h2 className="text-lg text-customBlackHeadColor font-SegoeUI font-semibold">
            Edit Personal Information
          </h2>
        </div>
      </div>
      <div className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-28">
          <div>
            <label className="block text-sm font-medium text-gray-700">First Name<span className="text-red-700 px-1">*</span></label>
            <input
              type="text"
              placeholder="First Name"
              className="mt-1 block w-full border border-gray-300 h-12 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.firstName}
              onChange={(e) => handleValidatedInput("firstName", e.target.value)}
            />
            {firstNameError && (
              <p className="text-red-500 text-xs mt-1">{firstNameError}</p>
            )}

          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Last Name<span className="text-red-700 px-1">*</span></label>
            <input
              type="text"
              placeholder="Last Name"
              className="mt-1 block w-full h-12 border border-gray-300 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.lastName}
              onChange={(e) => handleValidatedInput("lastName", e.target.value)}
            />
            {lastNameError && (
              <p className="text-red-500 text-xs mt-1">{lastNameError}</p>
            )}
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="text"
              placeholder="Email"
              className="mt-1 block w-full h-12 border border-gray-300 rounded-md pl-2 bg-[#FAFAFA] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              value={profileData.email}
              disabled
              onChange={(e) => handleInputChange("email", e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Phone Number</label>
            <PhoneInputWithCountrySelect
              international
              defaultCountry="US"
              value={profileData.phoneNumber}
              onChange={(value) => handleInputChange("phoneNumber", value)}
              className="input-no-focus"
            // style={{
            //   marginTop: "0.25rem",            
            //   display: "flex",                
            //   width: "100%",                   
            //   height: "3rem",                  
            //   border: "1px solid #D1D5DB",     
            //   outline: "none",                 
            //   borderRadius: "0.375rem",        
            //   paddingLeft: "0.5rem",           
            //   backgroundColor: "#FAFAFA",      
            //   boxShadow: "none",
            //   focus: "none",
            //   gap: "4px"
            // }}
            />
            {phoneNumberError && (
              <p className="text-red-500 text-xs mt-1">{phoneNumberError}</p>
            )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;
